import OrderArticles from "./OrderArticles";

export default OrderArticles;
